import React from 'react'

export default function Skill(props) {
    return (
        <div className="skill">
            <div className="skill-name">
                <p>{props.skillname}</p>
                <p className={`${props.skillname.split(" ")[0]}-per`}>{props.percentage}%</p>
            </div>
            <div className="php skill-graph">
                <div className="bar" style={{animation: "animategraph linear 1s", width: props.percentage + "%"}}></div>
            </div>
        </div>
    )
}
